import {
	COACH_SYSTEM_DATA_ACTION_TYPES,
	CoachSystemActions,
	CoachSystemData,
} from '../../../../types/coachSystemData'

const initialState: CoachSystemData = {
	_id: '',
	ID: '',
	firstName: '',
	lastName: '',
	startOfService: '',
	contact: {},
	imageUrl: null,
	account: null,
	engagementData: {},
	tier3Coach: {},
	tier2Coach: {},
	tier1Coach: {},
}

export default (
	state = initialState,
	action: CoachSystemActions
): CoachSystemData => {
	switch (action.type) {
		case COACH_SYSTEM_DATA_ACTION_TYPES.COACH_SYSTEM_SET_DATA: {
			return action.payload
		}
		default: {
			return state
		}
	}
}
